export const MessageType = {
  Success: 'success',
  Info: 'info',
  Warning: 'warning',
  Error: 'error',
};

export const ActionType = {
  SetMessage: 'SET_MESSAGE',
  ClearMessage: 'CLEAR_MESSAGE',
  SetPageTitle: 'SET_PAGE_TITLE',
  SetPageLoading: 'SET_PAGE_LOADING',
  SetPageFetching: 'SET_PAGE_FETCHING',
  SetPageError: 'SET_PAGE_ERROR',
  ClearPageError: 'CLEAR_PAGE_ERROR',
};

export const PageError = {
  Forbidden: '403',
  NotFound: '404',
};
